import React, { useContext } from "react";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import UserContext from "../context/UserContext";
import icosahedron from "../Assets/icosahedron.svg";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const drawerWidth = 320;
const useStyles = makeStyles((theme) => ({
  Drawer: {
    flexShrink: 0,
  },
  drawerPaperLight: {
    width: drawerWidth,
    justifyContent: "space-between",
    height:'100%',
    maxHeight:'100vh'
  },
  drawerPaperDark: {
    width: drawerWidth,
    justifyContent: "space-between",
    height:'100%',
    maxHeight:'100vh',backgroundColor:'#1f1f1f'
  },

  drawerHeader: {
    display: "flex",
    alignItems: "start",
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: "space-between",
    paddingTop: "5px",

  },
}));

function MyDrawer(props) {
  const { history } = props;
  const classes = useStyles();
  const theme = useTheme();
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const { State, CloseDrawer } = useContext(UserContext);

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      className={classes.Drawer}
      width="50%"
      open={State.DrawerState}
      classes={{
        paper: prefersDarkMode?classes.drawerPaperDark:classes.drawerPaperLight,
      }}
      
    >
      <div className={classes.drawerHeader}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginLeft: "10px",
            alignItems: "center",
            width: "35%",
            justifyContent: "space-between",
          }}
          onClick={() => {
            history.push("/");
            CloseDrawer();
          }}
        >
          <img
            src={icosahedron}
            alt="EA Logo"
            style={{
              height: "50px",
              width: "50px",
              filter:
                " invert(42%) sepia(56%) saturate(3250%) hue-rotate(324deg) brightness(93%) contrast(96%)",
            }}
          />
          <h3 style={{ fontFamily: "'Unica One', cursive" }}>EA</h3>
        </div>
        <IconButton onClick={CloseDrawer}>
          {theme.direction !== "rtl" ? (
            <ChevronLeftIcon />
          ) : (
            <ChevronRightIcon />
          )}
        </IconButton>
      </div>

      <List component="nav" aria-label="main mailbox folders">
        <ListItem
          button
          onClick={() => {
            CloseDrawer();
            history.push("/About");
          }}
        >
          <ListItemText primary="ABOUT" />
        </ListItem>

        <ListItem
          button
          onClick={() => {
            CloseDrawer();
            history.push("/Skills");
          }}
        >
          <ListItemText primary="SKILLS" />
        </ListItem>

        <ListItem
          button
          onClick={() => {CloseDrawer();
            history.push("/Contact");
          }}
        >
          <ListItemText primary="CONTACT" />
        </ListItem>
      </List>
      <Divider />
      <div style={{ color: prefersDarkMode?'#ffbc42':'#16213E', textAlign: "center",display:'flex',flexDirection:'row',justifyContent:'space-evenly',margin:'10px' }}>
        <GitHubIcon />
        <LinkedInIcon />
      </div>
    </Drawer>
  );
}

export default withRouter(MyDrawer);
